import { useTheme } from '@mui/material';
import {
  Bar,
  BarChart,
  Label,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

export const AppBarChart = ({
  data,
  xAxisKey,
  xLabel,
  yLabel,
  dataKey,
  yMin,
  yMax,
  fill,
  yMinOffset = 0,
  yMaxOffset = 0
}) => {
  const theme = useTheme();

  const CustomTick = (props) => {
    const { x, y, payload } = props;
    const words = payload.value.split(' ');
    const lines = [];
    let line = '';

    if (data.length > 3) {
      words.forEach((word) => {
        if ((line + word).length > 10) {
          lines.push(line);
          line = word;
        } else {
          line = line ? `${line} ${word}` : word;
        }
      });

      lines.push(line);
    } else {
      lines.push(payload.value);
    }

    return (
      <g transform={`translate(${x},${y + 10})`}>
        {lines.map((line, index) => (
          <text
            key={index}
            x={0}
            y={index * 12}
            textAnchor="middle"
            fill="white"
            fontSize={12}
            background="white"
          >
            {line}
          </text>
        ))}
      </g>
    );
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 0,
          bottom: 50,
        }}
      >
        <XAxis dataKey={xAxisKey} tick={<CustomTick />}>
          <Label
            value={xLabel}
            offset={10}
            position="bottom"
            style={{ fill: 'white' }}
          />
        </XAxis>
        <YAxis allowDecimals={false} domain={[(yMin < 0 ? yMin : 0) - (yMin < 0 ? 20 : yMinOffset), yMax + yMaxOffset]}>
          <Label
            value={yLabel}
            offset={10}
            angle={-90}
            position="insideLeft"
            style={{ textAnchor: 'middle', fill: 'white' }}
          />
        </YAxis>
        <Tooltip
          cursor={{ fill: 'transparent' }}
          formatter={(value, name) => [value, name.toUpperCase()]}
          sx={{
            backgroundColor: 'rgb(16 24 39)',
            border: '1px solid rgb(204, 204, 204)',
            borderRadius: '12px',
            textTransform: 'capitalize',
          }}
        />
        <Bar dataKey={dataKey} barSize={25} radius={[4, 4, 0, 0]} fill={fill}>
          <LabelList
            dataKey={dataKey}
            position="top"
            style={{
              ...theme.typography.caption,
              fill: 'white',
              textTransform: 'capitalize',
            }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
